import React from "react";
import PropTypes from "prop-types";
import { StaticQuery, graphql } from "gatsby";
// import Nav from "./nav";
// import Seo from "./seo";

const Layout = ({ children, seo }) => (
  <StaticQuery
    query={graphql`
      query {
        strapiHomepage {
          seo {
            metaTitle
            metaDescription
            shareImage {
              publicURL
            }
          }
        }
      }
    `}
    render={(data) => (
      <>
        {/* <Seo seo={seo} /> */}
        {/* <Nav /> */}
        <table width="970" border="0" cellSpacing="0" cellPadding="0" align="center" bgcolor="#FFFFFF">
  <tbody><tr>
    <td><a href="http://www.dongdahuoyun.com"><img src="/images/logo.gif" alt="上海空运,上海航空货运,上海航空运输" width="395" height="65" border="0" /></a></td>
    <td width="329"><img src="/images/topdh.gif" alt="上海空运热线：021-62682618" width="329" height="65" border="0" /></td>
    <td><table width="95%" border="0" cellSpacing="0" cellPadding="0" align="center">
      <tbody><tr>
        <td><table border="0" cellSpacing="0" cellPadding="0" align="right">
        <tbody>
        <tr align="center">
          <td width="60"></td>
          <td>|</td>
          <td height="25" width="60"></td>
        </tr></tbody></table></td>
      </tr>
      <tr>
        <td align="center"><img src="/images/yj.jpg" alt="应急热线" width="224" height="62" /></td>
      </tr>
    </tbody></table></td>
  </tr>
</tbody></table>
<table width="970" border="0" cellSpacing="0" cellPadding="0" align="center" bgcolor="#060d29">
  <tbody><tr align="center">
    <td height="25"><a href="/" className="TOP2">首&nbsp;页</a></td>
    <td width="1"><span className="STYLE1">|</span></td>
    <td><a href="/about" className="TOP2">公司简介</a></td>
    <td width="1"><span className="STYLE1">|</span></td>
    <td><a href="/category/news" className="TOP2">新闻中心</a></td>
     <td width="1"><span className="STYLE1">|</span></td>
    <td><a href="/international" className="TOP2">国际空运</a></td>
     <td width="1"><span className="STYLE1">|</span></td>
    <td><a href="/domestic" className="TOP2">国内空运</a></td>
     <td width="1"><span className="STYLE1">|</span></td>
    <td><a href="/service" className="TOP2">服务项目</a></td>
      <td width="1"><span className="STYLE1">|</span></td>
    <td><a href="/contact" className="TOP2">联系我们</a></td>
  </tr>
</tbody></table>
<table width="970" border="0" cellSpacing="0" cellPadding="0" align="center">
  <tbody><tr>
    <td><img src="/images/banner.gif" width="970" height="258" /></td>
  </tr>
</tbody></table>
        <main>{children}</main>
        {/* footer */}
        <table width="970" border="0" cellSpacing="0" cellPadding="0" align="center" bgcolor="#FFFFFF">
  <tbody><tr>
    <td valign="top"><table width="90%" border="0" cellSpacing="0" cellPadding="0" align="center">
  <tbody><tr align="center">
    <td><a href="http://www.fedex.com/cn/" target="_blank"><img src="/images/logo7.gif" alt="联邦快递" width="149" height="67" border="0" /></a></td>
    <td><a href="http://www.cn.dhl.com/zh.html" target="_blank"><img src="/images/logo2.jpg" alt="DHL" width="149" height="67" border="0" /></a></td>
    <td><a href="http://www.tnt.com.cn/" target="_blank"><img src="/images/logo3.jpg" alt="TNT中国国际快递" width="149" height="67" border="0" /></a></td>
    <td><a href="http://www.ups.com/cn" target="_blank"><img src="/images/logo4.jpg" alt="UPS" width="149" height="67" border="0" /></a></td>
    <td><a href="http://www.ems.com.cn/" target="_blank"><img src="/images/logo5.jpg" alt="中国邮政速递物流 " width="149" height="67" border="0" /></a></td>
  </tr>
</tbody></table>
</td>
  </tr>
</tbody></table>
<table cellSpacing="0" cellPadding="0" width="970" align="center" border="0" bgcolor="#FFFFFF">
        <tbody>
        <tr>
          <td height="5"></td></tr>
        <tr>
          <td bgcolor="#0391e3" height="3"></td></tr>
        <tr>
          <td height="1"></td></tr>
        <tr>
          <td height="50" align="center"><table width="60%" border="0" cellSpacing="0" cellPadding="0">
            <tbody><tr>
              <td style={{lineHeight:'22px', textAlign:'center'}}>Copyright © 2005-2014  上海东大货运有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <a href="http://beian.miit.gov.cn/" target="_blank">沪ICP备20005087号</a><br />地址：上海市沪青平公路248弄15号106室</td>
            </tr>
          </tbody></table></td>
        </tr>
        <tr>
      <td height="5"></td></tr></tbody></table>
      </>
    )}
  />
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
